// See Analytics Best Practices before adding a new event
export enum TrackedEventNames {
  testEvent = 'Test Event',
  // Generic user interactions
  buttonClicked = 'Button clicked',
  tabChanged = 'Tab changed',
  switchToggled = 'Switch toggled',
  selectionMade = 'Selection made',
  gridItemClicked = 'Grid item clicked',
  productClicked = 'Product clicked',
  // Flows
  fullSiteSearch = 'Full site search',
  // Page view events
  pageViewStarted = 'Page view started',
  pageViewEnded = 'Page view ended',
  // Farcaster
  farcasterFrameInteraction = 'Farcaster Frame Interacted With',
  purchaseFlow = 'Purchase flow'
}

// For backward compatibility
export const MixpanelTrackedEventNames = TrackedEventNames

export type UserInfo = {
  isStaff: boolean
  chain?: string
  publicAddress?: string
  email?: string | null
  name?: string | null
  username?: string | null
  profileId?: number | null
}

// For backward compatibility
export type MixpanelUserInfo = UserInfo

// Generic properties dictionary type
export type PropertiesDict = Record<string, any>

// Generic callback type for analytics responses
export type AnalyticsCallback = (response: any) => void
